import { FC, useState } from 'react';
import styles from './index.module.less';
import { Col, Row } from 'antd';
import SpotFlowChart from './SpotFlowChart';
import { formatPassengerFlowDate } from './config';
import SpotDetailDrawer from '@/views/expandstore/pages/passengerflowcount/components/SpotDetailDrawer';
import { isNotEmptyAny } from '@lhb/func';

/**
 * @Description 点位客流卡片
 */
const SpotFlowCard:FC<{
  itemData?: any;
}> = ({
  itemData
}) => {
  const [detail, setDetail] = useState<{ visible: boolean, data: any }>({ visible: false, data: {} });

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardTitle}>
          {itemData?.name || '-'}
          <span className={styles.cardTitleHint} onClick={() => { setDetail({ visible: true, data: { id: itemData.id } }); }}>详情</span>
        </div>
        <Row gutter={[16, 10]}>
          {itemData?.deviceTaskAnalysisList?.map((item, index) => (
            <Col span={index === itemData?.deviceTaskAnalysisList?.length - 1 && itemData?.deviceTaskAnalysisList?.length % 2 ? 24 : 12} key={index}>
              <div className={styles.cardCon}>
                <div className={styles.cardConData}>
                  <div className={styles.count}>{item.passbyCount}</div>
                  <div className={styles.time}>{formatPassengerFlowDate(item.date)}</div>
                </div>
                <div className={styles.cardConChart}>
                  <div className={styles.label}>平均过店客流</div>
                  {isNotEmptyAny(item.lineChart) ? <SpotFlowChart
                    width={136}
                    height={20}
                    xAxisData={item.lineChart?.map((item) => item.name)}
                    seriesData={[{
                      data: item.lineChart?.map((item) => item.value)
                    }]}/> : <div className={styles.chartholder}/>}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <SpotDetailDrawer
        data={detail}
        isDemonstrate={false}
        ableToChangepoint={false}
        setData={(visible) => {
          setDetail({
            ...detail,
            visible,
            data: {}
          });
        }} />
    </>
  );
};

export default SpotFlowCard;
